<span *ngIf="value && value.DisplayName">
  {{ value.DisplayName }}
  <br *ngIf="forceNewLine" />
  ({{ value.UserId }})
</span>
<span *ngIf="value && !value.DisplayName">
  {{ value.UserId ? value.UserId : 'Unknown' }}
</span>
<span *ngIf="!value">Unknown</span>
